/*
  SBI custom - one-line announcement ticker (mobile).

  On small screens the stock announcement bar wraps long messages onto 2-3 lines. The bar is sticky and the
  header is pinned right below it, so a tall bar covers the header while scrolling. This builds a single-line
  ticker from the same announcements: every enabled message, one after another, scrolling continuously and
  wrapping around. Desktop keeps the stock rotating bar (the messages fit on one line there).

  Pure progressive enhancement: if this file does not load, the stock bar is shown unchanged.
  Styles live in assets/custom.css (".sbi-ticker").
*/
(function () {
  var SPEED = 55; // pixels per second

  function build(bar) {
    if (!bar || bar.querySelector('.sbi-ticker')) return;

    // Swiper clones slides for looping - keep one copy of each announcement, in order.
    var seen = {};
    var messages = [];
    bar.querySelectorAll('.swiper-wrapper [data-slide]').forEach(function (slide) {
      var index = slide.getAttribute('data-index');
      if (index === null || seen[index]) return;
      seen[index] = true;
      var inner =
        slide.querySelector('.announcement-bar__item-inner-mobile-only') ||
        slide.querySelector('.announcement-bar__item-inner');
      if (inner && inner.textContent.trim()) messages.push(inner.innerHTML);
    });
    if (!messages.length) return;

    var ticker = document.createElement('div');
    ticker.className = 'sbi-ticker ff-body fs-body-50';
    var track = document.createElement('div');
    track.className = 'sbi-ticker__track';

    function group(hidden) {
      var el = document.createElement('div');
      el.className = 'sbi-ticker__group';
      if (hidden) el.setAttribute('aria-hidden', 'true');
      messages.forEach(function (html) {
        var item = document.createElement('div');
        item.className = 'sbi-ticker__item';
        item.innerHTML = html;
        if (hidden) {
          item.querySelectorAll('a').forEach(function (a) {
            a.setAttribute('tabindex', '-1');
          });
        }
        el.appendChild(item);
      });
      return el;
    }

    track.appendChild(group(false));
    ticker.appendChild(track);
    bar.appendChild(ticker);
    bar.classList.add('sbi-has-ticker');

    function layout() {
      // remove any previous clone, measure one group, then decide whether scrolling is needed
      var clones = track.querySelectorAll('.sbi-ticker__group[aria-hidden="true"]');
      clones.forEach(function (c) {
        c.remove();
      });
      ticker.classList.remove('sbi-ticker--scrolling');
      var first = track.firstElementChild;
      var width = first.getBoundingClientRect().width;
      if (!width || width <= ticker.clientWidth) return; // fits on one line: stay centred and static
      track.appendChild(group(true));
      track.style.setProperty('--sbi-ticker-duration', Math.max(8, width / SPEED) + 's');
      ticker.classList.add('sbi-ticker--scrolling');
    }

    layout();
    var timer;
    window.addEventListener('resize', function () {
      clearTimeout(timer);
      timer = setTimeout(layout, 150);
    });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(layout);
  }

  function init() {
    document.querySelectorAll('.announcement-bar').forEach(build);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
